var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0.05 0 21 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.004.174 9.712 8.866c.216.205.334.475.334.751 0 .575-.491 1.042-1.094 1.042h-1.531v7.5c0 .92-.783 1.667-1.75 1.667h-4.043v-5.012a1 1 0 0 0-1-1H9.466a1 1 0 0 0-1 1V20H4.425c-.967 0-1.75-.746-1.75-1.667v-7.5H1.144C.54 10.833.05 10.366.05 9.791c0-.276.118-.546.324-.741L10.096.174a.68.68 0 0 1 .908 0ZM8.466 20h4.166-4.166Z",
  clipRule: "evenodd"
})));
export default SvgHome;